import styled from 'styled-components';

import { brandFont } from 'components/layout/brand-font';

const Title = styled.h1`
  width: 100%;
  text-align: center;
  font: ${brandFont.headerOne};
  color: ${Styles.color.black};
  margin: 0;
`;

export default Title;
